import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'dm-general-error',
  templateUrl: './general-error.component.html',
  styleUrls: ['./general-error.component.css']
})
export class GeneralErrorComponent implements OnInit {
  toggleErrorDetailsView: boolean;
  returnUrl: string;

  constructor(private activeRoute: ActivatedRoute) { }

  ngOnInit() {
      this.toggleErrorDetailsView = false;
      const activeRouteQueryParams = this.activeRoute.queryParams;

      if (activeRouteQueryParams) {
        activeRouteQueryParams.subscribe((params: Params) => {
            this.returnUrl = params['return'];
        });
      }
  }

  goBack(): void {
    window.location.href = this.returnUrl;
  }

  showHideDetailsView(): void {
    this.toggleErrorDetailsView = !this.toggleErrorDetailsView;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/error-handling/general-error/general-error.component.ts